
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class SearchButton extends Vue {
  private get buttonText () {
    return this.$lang('SEARCHINPUT_BUTTON_TEXT')
  }
}
